import type { FC } from 'react'

import { IconStatusErrorFilled } from '@s-group/design-system-icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled, { useTheme } from 'styled-components'

const _OpeningTime: FC<{
  isExceptional: boolean
  className?: string
  children: React.ReactNode
}> = ({ isExceptional, className, children }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <span className={className} data-test-id="opening-hours">
      <span>{children}</span>
      {isExceptional && (
        <IconStatusErrorFilled
          color={theme.colors.info900}
          aria-label={t('Exceptional hours')}
          data-test-id="exceptional-hours"
        />
      )}
    </span>
  )
}

export const OpeningTime = styled(_OpeningTime)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  ['> * + *']: {
    marginLeft: theme.spacings.xxSmall,
  },
}))
